export default __webpack_public_path__ + "static/media/menu_top_duet_okara.eea80e90.svg";